import { gql } from '@apollo/client';

import {
  DrawAnswerFragment,
  ImageAnswerFragment,
  InteractiveResponseAnswerFragment,
  RichTextAnswerFragment,
} from 'approot/activity-builder/present/activity-answers.graphql';

export const SuggestedAnswerFragment = gql`
  fragment SuggestedAnswerFragment on ComponentSuggestedAnswersProperties {
    suggestedAnswerType
    suggestedAnswersScore
    suggestedAnswers {
      uuid
      componentId
      activityId
      answerType
      answer {
        ...RichTextAnswerFragment
        ...InteractiveResponseAnswerFragment
        ...DrawAnswerFragment
        ...ImageAnswerFragment
      }
      answerReferences {
        id
        row
        col
      }
    }
    markingGuides {
      id
      mark
      description
    }
  }
  ${InteractiveResponseAnswerFragment}
  ${RichTextAnswerFragment}
  ${DrawAnswerFragment}
  ${ImageAnswerFragment}
`;

export const SET_SUGGESTED_ANSWERS = gql`
  mutation SetSuggestedAnswers($input: SetSuggestedAnswersInput!) {
    setSuggestedAnswers(input: $input)
  }
`;
